var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host page"},[_c('DataTable',{attrs:{"title":"Доктора","service":_vm.service,"options":_vm.options,"fields":_vm.tableFileds,"scheme":_vm.scheme,"pageSize":5}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }